// created from 'edrolo/domains/attachments/constants.js'
export enum AttachmentParent {
  LESSON = 'lessons',
  EXAM = 'exams',
  BRANCH = 'branches',
  VIDEO = 'VIDEO',
  ACTIVITY = 'activities',
}

export enum AttachmentCategory {
  ASSESSMENT = 'assessment',
  FRAMEWORK = 'framework',
  RISK_ASSESSMENT = 'risk_assessment',
  STUDY_NOTES = 'study_notes',
  TEXTBOOK = 'textbook',
  UNIT_PLAN = 'unit_plan',
  WORKSHEET = 'worksheet',
  LESSON_SLIDES = 'lesson_slides',
  ACTIVITY = 'activity',
  QUESTION_SET = 'question_set',
}

export enum AttachmentType {
  FILE = 'file',
  LINK = 'link',
}

export enum AttachmentFileMIMEType {
  PDF = 'application/pdf',
  ZIP = 'application/zip',
  DOC = 'application/doc',
  MS_DOC = 'application/ms-doc',
  MS_WORD = 'application/msword',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  PPTX = 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
}

export enum AttachmentFileMIMETypeLabel {
  PDF_MIME_TYPE_LABEL = 'PDF',
  MS_DOC_MIME_TYPE_LABEL = 'WORD',
  ZIP_MIME_TYPE_LABEL = 'ZIP',
  PPTX_MIME_TYPE_LABEL = 'PPTX',
}
